export default __webpack_public_path__ + "static/media/how-does-it-work-3.dab2c5fe.png";